export const getLandingAnimationDelay = (index: number, maximumDelay = 0.48): string =>
  `${Math.min(index * 0.08, maximumDelay).toFixed(2)}s`
